<template>
  <div class="flex gap-x-4 items-center">
    <p class="font-light text-1324">
      {{ $t('mainAside.selectTheme') }}
    </p>
    <wui-select
      v-model="selectedColorTheme"
      :items="AVAILABLE_COLOR_THEMES"
      :size="32"
      @update:model-value="onColorThemeChange"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiSelect } from '@wui/common-library'
import { storeToRefs } from 'pinia'

import { type ColorThemeChoice, useColorTheme } from '../store'

const colorThemeStore = useColorTheme()
const { colorThemeChoice, AVAILABLE_COLOR_THEMES } = storeToRefs(colorThemeStore)
const { setColorTheme } = colorThemeStore
const selectedColorTheme = colorThemeChoice

const onColorThemeChange = (value: string | number) => {
  setColorTheme(value as ColorThemeChoice)
}
</script>
